import I18nProviderProps from "./I18nProvider.props";

export default class I18nProvider {
    private props: I18nProviderProps;

    constructor(props: I18nProviderProps) {
        this.props = props;
    }
    
    setProps(props: I18nProviderProps) {
        this.props = props;
    }

    get(selector: string, options?: unknown): string | undefined {
        if (options) {
            return this.props.t && this.props.t(selector, options);
        }
        return this.props.t && this.props.t(selector);
    }

    exists(selector: string): boolean {
        return !!(this.props.i18n && this.props.i18n.exists(selector));
    }
}